import { name as root } from '../actionTypes';

export const name = `${root}/hardwareproducts`

export const FETCH_HARDWARE_PRODUCTS_REQUEST = `${name}/request`
export const FETCH_HARDWARE_PRODUCTS_SUCCESS = `${name}/success`
export const FETCH_HARDWARE_PRODUCTS_FAILURE = `${name}/failure`

export const TOGGLE_PRODUCT_TO_CANCEL_FLAG = `${name}/toggleProductToCancelFlag`;

export const CANCEL_HARDWARE_PRODUCT_CLEAR = `${name}/cancelHardwareProduct/clear`
export const CANCEL_HARDWARE_PRODUCT_TO_REQUEST = `${name}/cancelHardwareProduct/request`;
export const CANCEL_HARDWARE_PRODUCT_TO_SUCCESS = `${name}/cancelHardwareProduct/success`;
export const CANCEL_HARDWARE_PRODUCT_TO_FAILURE = `${name}/cancelHardwareProduct/failure`;

export const SET_HARDWARE_SERIAL_NUMBER = `${name}/addHardware/setHardwareSerialNumber`
export const SET_CARD_SERIAL_NUMBER = `${name}/addHardware/setCardSerialNumber`
export const ADD_HARDWARE_CHANGE_STEP = `${name}/addHardware/addhardwarechangestep`

export const FETCH_HARDWARE_DEVICE_BY_SERIAL_REQUEST = `${name}/fetchdevicesbyserial/request`
export const FETCH_HARDWARE_DEVICE_BY_SERIAL_SUCCESS = `${name}/fetchdevicesbyserial/success`
export const FETCH_HARDWARE_DEVICE_BY_SERIAL_FAILURE = `${name}/fetchdevicesbyserial/failure`

export const FETCH_CARD_DEVICE_BY_SERIAL_REQUEST = `${name}/fetchcardbyserial/request`
export const FETCH_CARD_DEVICE_BY_SERIAL_SUCCESS = `${name}/fetchcardbyserial/success`
export const FETCH_CARD_DEVICE_BY_SERIAL_FAILURE = `${name}/fetchcardbyserial/failure`

export const ADD_HARDWARE_PRODUCT_CLEAR = `${name}/addhardwareproduct/clear`
export const ADD_HARDWARE_PRODUCT_REQUEST = `${name}/addhardwareproduct/request`
export const ADD_HARDWARE_PRODUCT_SUCCESS = `${name}/addhardwareproduct/success`
export const ADD_HARDWARE_PRODUCT_FAILURE = `${name}/addhardwareproduct/failure`

export const FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_REQUEST = `${name}/fetchdevicesdetailsbyserial/request`
export const FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_SUCCESS = `${name}/fetchdevicesdetailsbyserial/success`
export const FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_FAILURE = `${name}/fetchdevicesdetailsbyserial/failure`

export const FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_REQUEST = `${name}/getSmb2FirmwareVersion/request`
export const FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_SUCCESS = `${name}/getSmb2FirmwareVersion/success`
export const FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_FAILURE = `${name}/getSmb2FirmwareVersion/failure`

export const SAVE_SERIAL_REQUEST = `${name}/serial/save/request`;
export const SAVE_SERIAL_SUCCESS = `${name}/serial/save/success`;
export const SAVE_SERIAL_FAILURE = `${name}/serial/save/failure`;

export const UPDATE_SERIAL = `${name}/serial/update`;

export const SEARCH_SERIAL_REQUEST = `${name}/serial/search/request`;
export const SEARCH_SERIAL_SUCCESS = `${name}/serial/search/success`;
export const SEARCH_SERIAL_FAILURE = `${name}/serial/search/failure`;

export const RESET_SEARCH = `${name}/serial/search/reset`;

export const SAVE_START = `${name}/serial/save/start`;
export const SAVE_STOP = `${name}/serial/save/stop`;